export const REGISTER_ITEM = {
  headerTitle: {
    title: {
      vi: 'Đăng kí',
      en: 'Register',
    },
  },
  email: {
    title: {
      vi: 'Tài khoản',
      en: 'Email',
    },
    error: '',
  },
  passWord: {
    title: {
      vi: 'Mật khẩu',
      en: 'Password',
    },
    error: '',
  },
  passWordConfirm: {
    title: {
      vi: 'Xác nhận mật khẩu',
      en: 'Confirm Password',
    },
    error: '',
  },
  name: {
    title: {
      vi: 'Họ và tên',
      en: 'Full name',
    },
    error: '',
  },
  registerButton: {
    title: {
      vi: 'Đăng kí',
      en: 'Create account',
    },
  },
  googleButton: {
    title: {
      vi: 'Google',
      en: 'Google',
    },
  },
  loginAccount: {
    title: {
      vi: 'Đã có tài khoản, đăng nhập!',
      en: 'Login',
    },
    path: '/login/',
  },
};
